import { useMemo } from 'react';
import { window } from '../../globals';
import { isFeatureEnabled } from './featureFlags';
import { QUALITY } from '../../../shared/featureFlags/flagNames';
import { hasTierFeature } from '../../../shared/subscriptions';

/**
 * Frontend helper function for checking if the user's org has the Quality feature enabled.
 * It checks the stored window values and the enabled feature flags which includes features granted by the org's tier.
 */
export const isQualityEnabled = () =>
  window.quality_policy_enabled ||
  // We include this because looking at the tier feature Set is faster than our final lookup in enabledFeatureFlags
  hasTierFeature(window.user?.organization?.stripe_plan, QUALITY) ||
  isFeatureEnabled(QUALITY);

/**
 * Frontend helper hook for checking if the user's org has the Security feature enabled and memoizes the result across rerenders.
 * It checks the stored window values and the enabled feature flags which includes features granted by the org's tier.
 * This provides a minor perf improvement, as we don't need to iterate through enabledFeatureFlags[]
 * on every re-render of the component like with `isFeatureEnabled`.
 */
export const useIsQualityEnabled = () =>
  useMemo(
    () =>
      isQualityEnabled(),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We want to refresh this if the enabledFeatureFlags change or if one of the other value change.
    [window.enabledFeatureFlags, window.quality_policy_enabled, window.user?.organization?.stripe_plan],
  );
